import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IComponent } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

interface BulkReplaceInterface {
  selectedComponent: IComponent;
  replaceComponent: IComponent;
  assemblyIds: number[];
}

export const useBulkReplaceAssemblyComponents = () => {
  return useMutation({
    mutationFn: replaceAssemblyComponents,
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.viewAssembliesWithComponents.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.assemblyComponents.invalidateAll(),
      );
    },
  });
};

const replaceAssemblyComponents = async (payload: BulkReplaceInterface) => {
  const response = await requestCCApi({
    url: `/assemblyComponents`,
    method: 'PATCH',
    data: {
      filter: {
        'assembly_id.list': payload.assemblyIds.join('|'),
        component_id: payload.selectedComponent.id,
      },
      data: {
        component_id: payload.replaceComponent.id,
      },
    },
  });

  return response.updated;
};
